// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__3JBmz","list":"PatternAutocomplete_list__HVxRU"};